import {Container} from 'inversify'

import {DI} from './types'
import {DI_RETURN_TYPES} from './return-types'

import {MonitoringModule} from './modules/monitoring'
import {StorageModule} from './modules/storage'
import {APIModule} from './modules/api'
import {AnalyticModule} from './modules/analytic'
import {ServicesModule} from './modules/services'
import {PageOptionsModule} from './modules/page-options'
import {PageDataModule} from './modules/page-data'
import {AppModule} from './modules/app'
import {LoginModule} from './modules/login'
import {CatalogModule} from './modules/catalog'
import {FavouriteModule} from './modules/favourite'
import {FormTestingModule} from './modules/form-testing'

const ApplicationContainer = new Container({
  defaultScope: 'Singleton',
})

export const initializeContainer = (container: Container) => {
  container.load(MonitoringModule)
  container.load(StorageModule)
  container.load(APIModule)
  container.load(AnalyticModule)
  container.load(ServicesModule)
  container.load(PageOptionsModule)
  container.load(PageDataModule)
  container.load(AppModule)
  container.load(LoginModule)
  container.load(CatalogModule)
  container.load(FavouriteModule)
  container.load(FormTestingModule)
}

export const destroyContainer = (container: Container) => {
  container.unload(MonitoringModule)
  container.unload(StorageModule)
  container.unload(APIModule)
  container.unload(AnalyticModule)
  container.unload(ServicesModule)
  container.unload(PageOptionsModule)
  container.unload(PageDataModule)
  container.unload(AppModule)
  container.unload(LoginModule)
  container.unload(CatalogModule)
  container.unload(FavouriteModule)
  container.unload(FormTestingModule)
}

if (process.env.NODE_ENV !== 'test') {
  initializeContainer(ApplicationContainer)
}

export function getInjection<K extends keyof typeof DI>(symbol: K): DI_RETURN_TYPES[K] {
  try {
    return ApplicationContainer.get(DI[symbol])
  } catch (e) {
    if (e instanceof Error && /No matching bindings|Could not resolve|TIS001/.test(e.message)) {
      throw new Error(
        `[DI] Символ "${symbol}" не зарегистрирован в клиентском контейнере. ` +
          `Если это серверный сервис — убедитесь, что код выполняется в серверном графе.`,
      )
    }
    throw e
  }
}

export {ApplicationContainer}
